/** @format */

import { useTranslation } from 'react-i18next';
import search from '../../assets/icon/search.svg';

export const Search = ({ keyword, onChange, onSubmit }) => {
  const { t } = useTranslation();

  const handleOnKeyDown = e => {
    if (e.key === 'Enter' || e.key === 'NumpadEnter') {
      onSubmit();
    }
  };
  return (
    <div className="search-component">
      <input
        value={keyword}
        onChange={onChange}
        onKeyDown={handleOnKeyDown}
        className="search-component-input"
        placeholder={t('Tickets.searchPlaceholder')}
      />
      <button onClick={onSubmit} className="search-component-button">
        <img alt="search button" src={search} />
      </button>
    </div>
  );
};
